import * as $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import { on, Options, debounce } from '../utils/decorators';
import axios from 'axios';
import 'url-polyfill';

const swiftype_engine_id = (<any>window).DJANGO.swiftypeEngineID;
const swiftype_site = (<any>window).DJANGO.swiftypeSite;

const search_suggestions_active_class = 'search-suggestions--active';
const search_suggestion_selector = '.search-suggestions__suggestion';
const search_suggestion_selected_class = 'search-suggestions__suggestion--selected ';
const search_suggestion_item_li = $('<li class="search-suggestions__suggestion"></li>');
const search_suggestion_item_a = $('<a class="search-suggestions__link"></a>');

const up_key = 38;
const down_key = 40;
const esc_key = 27;

const cache = {};

@Options({
    template: false,

    ui : {
        searchInput:        '[data-js-ui=search-input-with-suggestions]',
        searchResults:      '[data-js-ui=search-suggestions]',
        closeBtn:           '[data-js-ui=search-close-btn]',
    }
})

export default class SearchView extends Marionette.View<Backbone.Model>{
    currentRecord = null;
    totalRecords = null;
    searchTerm = null;

    @on('click @ui.searchClearBtn')
    onSearchClearBtnClick(e: JQueryEventObject) {
        this.ui.searchInput.val('').focus();
    }

    @on('keyup @ui.searchInput')
    onSearchInputKeyUp(e: JQueryEventObject) {
        const key = (e.keyCode ? e.keyCode : e.which);

        if (key === down_key) {
            this.selectNextRecord();
        }

        if (key === up_key) {
            this.selectPreviousRecord();
        }

        if (key === esc_key) {
            $('[data-js-ui=search-close-btn]').click();
            $('[data-js-ui=search-open-btn]').focus();
        }
    }

    // @on('blur @ui.searchInput')
    @debounce(100)
    onSearchInputBlur(e: JQueryEventObject) {
        this.hideSuggestions();
    }

    @debounce(400)
    @on('input @ui.searchInput')
    onSearchInputChange(e: JQueryEventObject) {
        const q = (<HTMLInputElement>e.currentTarget).value;

        // Hide results if not enough chars and do nothing
        if (!q || q.length < 2) {
            return this.hideSuggestions();
        }

        this.makeSearchRequest(q).then(response => {
            let suggestions = [];

            if (_.has(response.data.info.page, 'spelling_suggestion') && response.data.record_count === 0) {
                suggestions.push(
                    response.data.info.page.spelling_suggestion.text
                );
            }

            suggestions = response.data.records.page.reduce((carry, record) => {
                if (_.has(record.highlight, 'sections')) {
                    const sectionTexts = this.tokenise(record.highlight.sections);

                    sectionTexts.forEach(t => {
                        if (t.split(' ').length <= 6) {
                            carry.push(t);
                        }
                    });
                }

                if (_.has(record.highlight, 'internal_title')) {
                    const internalTitleTexts = this.tokenise(record.highlight.internal_title);

                    internalTitleTexts.forEach(t => {
                        if (t.split(' ').length <= 6) {
                            carry.push(t);
                        }
                    });
                }

                const titleTexts = this.tokenisePlain(record.title, q);

                titleTexts.forEach(t => {
                    if (t.split(' ').length <= 6) {
                        carry.push(t);
                    }
                });

                return carry;
            }, suggestions);

            // Remove dupes
            suggestions = _.uniq(suggestions);

            // Sort by length
            suggestions = _.sortBy(suggestions, suggestion => {
                return suggestion.length;
            });

            // Only show first 10
            suggestions = suggestions.slice(0, 10);

            // Make for dispalay
            suggestions = suggestions.map(suggestion => ({
                plain: suggestion,
                highlighted: suggestion.replace(new RegExp(q, 'ig'), '<b>$&</b>'),
                url: '/search/?q=' + suggestion,
            }));

            this.currentRecord = null;
            this.totalRecords = null;

            if (!suggestions.length) {
                return this.hideSuggestions();
            }

            this.showSuggestions(suggestions, q);
        });
    }

    selectNextRecord() {
        if (this.currentRecord === null) {
            this.currentRecord = 0;
        } else {
            this.currentRecord++;

            if (this.currentRecord >= this.totalRecords) {
                this.currentRecord = null;
            }
        }

        $(search_suggestion_selector).removeClass(search_suggestion_selected_class);

        if (this.currentRecord !== null) {
            const item = $(search_suggestion_selector).eq(this.currentRecord);

            // add hover class
            item.addClass(search_suggestion_selected_class);

            // update input
            this.ui.searchInput.val(
                item.data('phrase')
            );
        } else {
            this.ui.searchInput.val(this.searchTerm);
        }
    }

    selectPreviousRecord() {
        if (this.currentRecord === null) {
            this.currentRecord = this.totalRecords - 1;
        } else {
            this.currentRecord--;

            if (this.currentRecord <= -1) {
                this.currentRecord = null;
            }
        }

        $(search_suggestion_selector).removeClass(search_suggestion_selected_class);

        if (this.currentRecord !== null) {
            const item = $(search_suggestion_selector).eq(this.currentRecord);

            // add hover class
            item.addClass(search_suggestion_selected_class);

            // update input
            this.ui.searchInput.val(
                item.data('phrase')
            );
        } else {
            this.ui.searchInput.val(this.searchTerm);
        }
    }

    tokenise(phrase) {
        // lower the case
        let phrases = phrase.toLowerCase();

        // split by em
        phrases = phrases.split('<em>');

        // remove first one as it's junk or empty
        phrases.shift();

        return phrases.map(p => {
            // remove the closing tag
            p = p.replace('</em>', '');

            // amperstand
            p = p.replace('&amp;', '');

            // remove non alphanumeric and space
            p = p.replace(/[^A-Za-z0-9 -]/g, '');

            // excessive spaces
            p = p.replace(/\s{2,}/, ' ');

            return p.trim();
        });
    }

    tokenisePlain(phrase, q) {
        // lower the case
        let phrases = phrase.toLowerCase();

        // split by phrase
        phrases = phrases.split(q);

        // remove the first one as it's junk or empty
        phrases.shift();

        return phrases.map(p => {
            // append the query again
            p = q + p;

            // amperstand
            p = p.replace('&amp;', '');

            // remove non alphanumeric and space
            p = p.replace(/[^A-Za-z0-9 -]/g, '');

            // excessive spaces
            p = p.replace(/\s{2,}/, ' ');

            return p.trim();
        });
    }

    makeSearchRequest(searchTerm?) {
        if (searchTerm in cache) {
            return cache[searchTerm];
        }

        let paramsObj = {
            q: searchTerm,
            engine_key: swiftype_engine_id,
            spelling: 'always',
            per_page: 50,
        }

        // @ts-ignore
        const params = new URLSearchParams(paramsObj);

        // add site
        params.append('filters[page][site]', swiftype_site);

        // add to cache
        cache[searchTerm] = axios.get(
            `https://api.swiftype.com/api/v1/public/engines/search.json?` + params.toString()
        )

        return cache[searchTerm];
    }

    hideSuggestions() {
        this.ui.searchResults.removeClass(search_suggestions_active_class);
    }

    showSuggestions(records, searchTerm?) {
        // Remove children
        this.ui.searchResults.empty();

        // Re-populate results
        for (let i in records) {
            const record = records[i];

            const listItem = search_suggestion_item_li.clone();
            const anchor = search_suggestion_item_a.clone();

            anchor
                .attr('href', record.url)
                .html(record.highlighted);

            listItem
                .data('index', i)
                .data('phrase', record.plain)
                .append(anchor);

            listItem.on('mouseover', (e) => {
                const item = $(e.currentTarget);

                $(search_suggestion_selector).removeClass(search_suggestion_selected_class);

                this.currentRecord = item.data('index');

                item.addClass(search_suggestion_selected_class);
            });

            listItem.on('mouseout', (e) => {
                const item = $(e.currentTarget);

                this.currentRecord = null;

                item.removeClass(search_suggestion_selected_class);
            });

            this.ui.searchResults.append(listItem);
        }

        $('body').one('click.suggestions', e => {
            let target = $(event.target);

            if(e.button == 0) {
                if(!target.closest('.search-suggestions').length && !target.hasClass('search-bar')) {
                    this.hideSuggestions();
                    $('body').off('click.suggestions');
                }
            }
        });

        this.totalRecords = records.length;
        this.searchTerm = searchTerm;

        this.ui.searchResults.addClass(search_suggestions_active_class);
    }
}



// WEBPACK FOOTER //
// ./@modules/views/search-view.ts